export default "__VITE_ASSET__DVkYR6h3__"